import { render, staticRenderFns } from "./CheckinAdd.vue?vue&type=template&id=0b50f92c&scoped=true"
import script from "./CheckinAdd.vue?vue&type=script&lang=js"
export * from "./CheckinAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50f92c",
  null
  
)

export default component.exports